import { render } from "./Admin_Inventario.vue?vue&type=template&id=7f886151"
import script from "./Admin_Inventario.vue?vue&type=script&lang=js"
export * from "./Admin_Inventario.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__